(function(){
  function initUpsellBlocks(){
    document.querySelectorAll('[data-upsell-block]').forEach(function(block){
      if(block.dataset.upsellInit)return;
      block.dataset.upsellInit='1';
      var selVid=parseInt(block.dataset.vid||'0');
      var btn=block.querySelector('[data-upsell-add]');
      var btnText=btn?btn.querySelector('[data-upsell-text]'):null;
      var variantBtns=block.querySelectorAll('[data-upsell-variant]');
      variantBtns.forEach(function(vb){
        if(vb.disabled)return;
        vb.addEventListener('click',function(){
          variantBtns.forEach(function(x){x.removeAttribute('data-active');});
          vb.setAttribute('data-active','');
          selVid=parseInt(vb.dataset.vid||'0');
        });
      });
      if(btn){
        btn.addEventListener('click',function(){
          if(btn.disabled||!selVid)return;
          btn.disabled=true;
          if(btnText)btnText.textContent='...';
          Cart.addItem({
            id:selVid,
            quantity:1,
            success:function(){
              if(btnText)btnText.textContent='Added \u2713';
              setTimeout(function(){
                if(btnText)btnText.textContent='Add to Bag';
                btn.disabled=false;
              },2500);
            },
            error:function(){
              if(btnText)btnText.textContent='Add to Bag';
              btn.disabled=false;
            },
            complete:function(){}
          });
        });
      }
    });
  }
  document.addEventListener('wc-init.section-pdp',function(){
    setTimeout(initUpsellBlocks,0);
  });
})();
